export function overrides(theme) {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": {
            borderColor: "#1D5AB9",
            borderWidth: 2,
            color: "black", // Set your pre-defined strong color here
          },
          "& .MuiOutlinedInput-notchedOutline": {
            color: "black",
            borderColor: "#1D5AB9", // Set your custom border color
            borderWidth: 2,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            color: "black",
            borderWidth: 2,
            borderColor: "#1D5AB9", // Set a different border color on hover if desired
          },
          "& .MuiOutlinedInput-root": {
            // - The Input-root, inside the TextField-root
            "& fieldset": {
              // - The <fieldset> inside the Input-root
              borderColor: "#0000005C", // - Set the Input border
            },
            "&:hover fieldset": {
              borderColor: "#1D5AB9", // - Set the Input border when parent has :hover
            },
            "&.Mui-focused fieldset": {
              // - Set the Input border when parent is focused
              borderColor: "#1D5AB9",
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: "white",
          borderRadius: 10,
          height: 50,
          minWidth: 0,
          backgroundColor: "#1D5AB9", // Set your pre-defined strong color here
          "&:hover": {
            backgroundColor: "#1D5AB9", // Set a different color on hover if desired
          },
        },
      },
    },
  };
}
